import { render, staticRenderFns } from "./user_multiselect.vue?vue&type=template&id=2d204d2d&scoped=true"
import script from "./user_multiselect.vue?vue&type=script&lang=js"
export * from "./user_multiselect.vue?vue&type=script&lang=js"
import style0 from "./user_multiselect.vue?vue&type=style&index=0&id=2d204d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d204d2d",
  null
  
)

export default component.exports